/**
 * Sends logs conditionally.
 */
export const conditionalStream = (predicate) => (stream) => (event) => {
    if (predicate(event)) {
        stream(event);
    }
};
//# sourceMappingURL=conditionalStream.js.map